import { createAction } from 'Lib/reduxUtils';

import {
  NUDGE_RECEIVED,
  WEBSOCKET_CONNECTED,
  WEBSOCKET_DISCONNECTED,
  WEBSOCKET_INIT,
  WEBSOCKET_MESSAGE,
  WEBSOCKET_PING,
  WEBSOCKET_PING_TIMEOUT,
  WEBSOCKET_PONG,
} from './constants';

export const websocketInit = createAction(WEBSOCKET_INIT);
export const websocketConnected = createAction(WEBSOCKET_CONNECTED, (clientTime: number) => ({
  clientTime,
}));
export const websocketDisconnected = createAction(WEBSOCKET_DISCONNECTED, (error?: any) => ({
  error,
}));
export const websocketMessage = createAction(WEBSOCKET_MESSAGE, (data: any) => data);
export const websocketPing = createAction(WEBSOCKET_PING);
export const websocketPingTimeout = createAction(WEBSOCKET_PING_TIMEOUT);
export const websocketPong = createAction(WEBSOCKET_PONG);
export const nudgeReceived = createAction(
  NUDGE_RECEIVED,
  (
    nudge: any,
    { startTime, upstreamTime }: Partial<{ startTime: number; upstreamTime: number }> = {},
    clientTime: number = Date.now()
  ) => ({
    nudge,
    startTime,
    upstreamTime,
    clientTime,
  })
);
